import React__default from 'react';
import { Caption, Body } from '../Typography/index.es.js';
import { CommonStyles } from '../BaseProps/index.es.js';
import { CustomLink } from '../CustomLink/CustomLink.es.js';
import { themeColor } from '../../configs/Colors/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TextLink = (_a) => {
  var _b = _a, {
    href,
    children,
    hasColor = true,
    disabled = false,
    size = "m",
    prefixIcon,
    suffixIcon
  } = _b, rest = __objRest(_b, [
    "href",
    "children",
    "hasColor",
    "disabled",
    "size",
    "prefixIcon",
    "suffixIcon"
  ]);
  var _a2, _b2;
  const textColor = disabled ? themeColor.disable : hasColor ? themeColor.link500 : themeColor.textSecondary;
  const Comp = size === "s" ? Caption : Body;
  return /* @__PURE__ */ React__default.createElement(StyledLink, __spreadValues({
    href: href || ""
  }, rest), /* @__PURE__ */ React__default.createElement(Wrapper, null, prefixIcon && React__default.cloneElement(prefixIcon, {
    size: ((_a2 = prefixIcon == null ? void 0 : prefixIcon.props) == null ? void 0 : _a2.size) || 16,
    color: textColor
  }), typeof children === "string" ? /* @__PURE__ */ React__default.createElement(Comp, {
    level: 1,
    weight: "regular",
    color: textColor,
    hoverColor: "link600",
    style: { marginBottom: "3px" }
  }, children) : /* @__PURE__ */ React__default.createElement("span", {
    style: { color: textColor },
    className: "text"
  }, children), suffixIcon && React__default.cloneElement(suffixIcon, {
    size: ((_b2 = suffixIcon == null ? void 0 : suffixIcon.props) == null ? void 0 : _b2.size) || 16,
    color: textColor
  })));
};
const StyledLink = styled(CustomLink)`
  ${CommonStyles}
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  width: max-content;
  &:hover {
    .text {
      color: ${themeColor.link600} !important;
    }
    path[stroke],
    rect[stroke],
    line {
      stroke: ${themeColor.link600};
    }
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${themeColor.link600};
    }
  }
`;

export { TextLink };
